export default __webpack_public_path__ + "static/media/warranty-portal.57c24923.png";